<template lang="pug">
  b-modal#promoMemberAssign(
  ref="promoMemberAssign"
  :title="$t('ui.combine.promo_member_assign')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  size="lg"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      div.row
        div.col-sm-12.col-md-6.col-lg-6
          b-form-group(:label="$t('ui.account_id')" disabled).mb-0
            DebounceInput(
              size="sm"
              ref="account_id"
              required
              type="text"
              :dirty="$v.account_id.$dirty"
              :error="$v.account_id.$error"
              v-model.trim.lazy="$v.account_id.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.account_id" :name="$t('ui.account_id')")
        div.col-sm-12.col-md-6.col-lg-6
          b-form-group(:label="$t('ui.criteria')").mb-0
            VipCriteriaList(
              ref="criteria"
              size="sm"
              required
              type="array"
              :dirty="$v.criteria.$dirty"
              :error="$v.criteria.$error"
              v-model.trim.lazy="$v.criteria.$model"
              :disabled="loading"
              :hideOpt="hideOpt"
              @input="resetValue"
            )
            ValidateResult(:value="$v.criteria" :name="$t('ui.criteria')")
      div.row
        div.col-sm-12.col-md-6.col-lg-6
          b-form-group(:label="$t('ui.provider_list')" style="overflow: hidden scroll; height: 42vh;").mb-0
            table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
              tr
                th.text-center
                  b-form-checkbox.checkboxModal(v-model="allSelected" @change="selectAll")
                th
                  span.font-weight-bold {{ allSelected  ? $t('ui.unselect_all') : $t('ui.select_all') }}
              tr(v-for='p in pList')
                td.text-center
                  b-form-checkbox.checkboxModal(v-model="provider_list" :value='p.value')
                td {{ p.text }}
          ValidateResult(:value="$v.provider_list" :name="$t('ui.provider_list')")
        div.col-sm-12.col-md-6.col-lg-6
          b-form-group(:label="$t('ui.base_amount')").mb-0
            DebounceInput(
              size="sm"
              ref="base_amount"
              required
              type="text"
              :dirty="$v.base_amount.$dirty"
              :error="$v.base_amount.$error"
              v-model.trim.lazy="$v.base_amount.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.base_amount" :name="$t('ui.base_amount')")
          b-form-group(:label="$t('ui.bonus_amount')").mb-0
            DebounceInput(
              size="sm"
              ref="bonus_amount"
              required
              type="text"
              :dirty="$v.bonus_amount.$dirty"
              :error="$v.bonus_amount.$error"
              v-model.trim.lazy="$v.bonus_amount.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.bonus_amount" :name="$t('ui.bonus_amount')")
          b-form-group(:label="$t('ui.rollover')").mb-0
            DebounceInput(
              size="sm"
              ref="rollover"
              type="text"
              :dirty="$v.rollover.$dirty"
              :error="$v.rollover.$error"
              v-model.trim.lazy="$v.rollover.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.rollover" :name="$t('ui.rollover')")
          //- b-form-group(:label="$t('ui.withhold_bonus')").mb-0
          //-   div.d-flex
          //-     label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
          //-       input.switch-input(
          //-         type="checkbox"
          //-         required
          //-         :dirty="$v.withhold_bonus.$dirty"
          //-         :error="$v.withhold_bonus.$error"
          //-         v-model.trim.lazy="$v.withhold_bonus.$model"
          //-         :disabled="loading"
          //-       )
          //-       span.switch-slider(:data-checked='on' :data-unchecked='off')
          //-   ValidateResult(:value="$v.withhold_bonus" :name="$t('ui.withhold_bonus')")
          b-form-group(:label="$t('ui.withhold_amount')" v-if="criteria == 'WIN'").mb-0
            DebounceInput(
              size="sm"
              ref="withhold_amount"
              required
              type="text"
              :dirty="$v.withhold_amount.$dirty"
              :error="$v.withhold_amount.$error"
              v-model.trim.lazy="$v.withhold_amount.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.withhold_amount" :name="$t('ui.withhold_amount')")
          b-form-group(:label="$t('ui.max_withdraw_amount')").mb-0
            DebounceInput(
              size="sm"
              ref="max_withdraw_amount"
              required
              type="text"
              :dirty="$v.max_withdraw_amount.$dirty"
              :error="$v.max_withdraw_amount.$error"
              v-model.trim.lazy="$v.max_withdraw_amount.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.max_withdraw_amount" :name="$t('ui.max_withdraw_amount')")
          b-form-group(:label="$tc('ui.remark')").mb-0
            DebounceInput(
              size="sm"
              type="text"
              :dirty="$v.remark.$dirty"
              :error="$v.remark.$error"
              v-model.trim.lazy="$v.remark.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.remark" :name="$t('ui.remark')")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import VipCriteriaList from "@/library/VipCriteriaList";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);
const atLeastOneProvider = (value) => value.length > 0;

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    VipCriteriaList
  },
  props: {
    item: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      parent_id: "",
      account_id: "",
      criteria: "",
      base_amount: 0,
      bonus_amount: "",
      rollover: "",
      withhold_bonus: false,
      withhold_amount: 0,
      max_withdraw_amount: 0,
      remark: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      hideOpt: ['DEPOSIT'],
      provider_list: [],
      providerList: [],
      allSelected: false,
      pList: [],
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
  },
  validations: {
    account_id: {
      required,
      alphaNum,
      maxLength: maxLength(20)
    },
    criteria: {
      required
    },
    base_amount: {
      required,
      decimal
    },
    bonus_amount: {
      required,
      decimal
    },
    rollover: {
      required,
      integer
    },
    // withhold_bonus: {
    //   required
    // },
    withhold_amount: {
      required : requiredIf(function () {
        return this.criteria == 'WIN';
      }),
      decimal
    },
    max_withdraw_amount: {
      required,
      decimal
    },
    remark: {
      required
    },
    provider_list: {
      atLeastOneProvider,
      minLength: minLength(1)
    }
  },
  watch : {
    provider_list(newValue, oldValue) {
      if (newValue.length === 0)
        this.allSelected = false;
      else if (newValue.length === this.pList.length)
        this.allSelected = true;
      else
        this.allSelected = false;
    }
  },
  methods: {
    resetValue() {
      if (this.criteria == "TURNOVER")
        this.withhold_amount = 0;
    },
    selectAll: function() {
      this.provider_list = [];

      let list = this.pList;

      if (this.allSelected) {
        for(var i = 0; i < list.length; i++) {
          this.provider_list.push(list[i].value);
        }
      }
    },
    removeDuplicate(arr) {
      let s = new Set(arr);
      let it = s.values();
      return Array.from(it);
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.promotionMemberAssignUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          member_id: this.item.account_id,
          criteria: this.criteria,
          base_amount: this.base_amount,
          bonus_amount: this.bonus_amount,
          rollover: this.rollover,
          withhold_bonus: false,
          // withhold_bonus: this.withhold_bonus,
          withhold_amount: this.criteria == "TURNOVER" ? 0 : this.withhold_amount,
          max_withdraw_amount: this.max_withdraw_amount,
          remark: this.remark
        };

        if (this.provider_list.length != this.pList.length)
          json.provider_list = this.removeDuplicate(this.provider_list.sort()).toString();

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.promoMemberAssign.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "promo_member_assign", this.feedback.status);
                  this.$refs.promoMemberAssign.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    getPList() {
      let list = this.providerList;

      let result = [];

      for(var i = 0; i < list.length; i++) {
        result.push({value: list[i].provider_code, text: list[i].provider_name, checked: false});
      }
      this.pList = result;
    },
    getProviderList: function() {
      let url = config.providerMaintenanceOperatorListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        is_free: false,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.providerList = (response.data.dt || []).filter(item => item.aggregator !== "GTA");
                this.getPList();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.account_id = this.item.account_id;
      this.criteria = "";
      this.base_amount = 0;
      this.bonus_amount = "";
      this.rollover = "";
      this.withhold_bonus = false;
      this.withhold_amount = 0;
      this.max_withdraw_amount = 0;
      this.remark = "";
      this.provider_list = [];
      this.pList = [];
      this.allSelected = false;
      this.getProviderList();
      this.$refs.criteria.$el.focus();
    }
  }
};
</script>
